import type {TaxiOrderRequest} from "@/api/apiClient";
import {useConfiguration, usePublicOrderHash} from "@/features/configuration";
import {clearSpaces} from "@/utils/string";
import {generateUUID} from "@/utils/uuid";
import {useOrderContext} from "../context/OrderContext";

export function useOrderPayload() {
    const {data: configuration} = useConfiguration();
    const {orderHash} = usePublicOrderHash();
    const {orderDraft} = useOrderContext();

    const createPayload = (
        priceToken: string | undefined,
        paymentType: TaxiOrderRequest["publicOrderPaymentType"]
    ): TaxiOrderRequest => {
        return {
            orderUuid: generateUUID(),
            publicHash: orderHash ?? undefined,
            paymentMethod: configuration?.supportedPaymentMethods?.includes("COMPANY")
                ? "COMPANY"
                : paymentType === "CASH"
                  ? "PASSENGER_CASH"
                  : "PASSENGER_CARD",
            stops: [
                {
                    location: configuration?.fixedPickup ?? orderDraft.pickup?.location,
                    type: "PICKUP",
                    contact: {
                        name: orderDraft.name,
                        phoneNumber: clearSpaces(orderDraft.phoneNumber),
                    },
                },
                {
                    location: configuration?.fixedDestination ?? orderDraft.dropoff?.location,
                    type: "DROP_OFF",
                },
            ],
            driverCallsOrderer: false,
            type: "NORMAL",
            internalNote: "kiosk",
            tierId: "TIER_DEFAULT",
            priceToken,
            publicOrderPaymentType: paymentType,
        };
    };

    const validateOrder = () => {
        if (!orderDraft.pickup?.location || !orderDraft.dropoff?.location) {
            return {
                isValid: false,
                error: "missing_locations",
            };
        }
        return {isValid: true};
    };

    return {
        createPayload,
        validateOrder,
        orderDraft,
    };
}
